import { toRepeatQuery } from './queryString'
import { DownloadInventoryStatusesReq, GetGoodsCodeOptionsReq, GetInventoryStatusesReq } from './types'

/**
 * ST02 재고현황 화면이 쓰는 엔드포인트.
 *
 * 동작별 배선 (LOGISPRD-10655 기준표):
 * | 동작     | 2.0 API                                | 1.0 API           | 비고                     |
 * |----------|----------------------------------------|-------------------|--------------------------|
 * | 화면     | —                                      | —                 | FE 전용 (모바일 mst02 포함, BE 분기 없음) |
 * | 조회     | `GET /api/v1/inventory/statuses`       | /api/grid/search  | PR #2531 (LOGISPRD-9592) |
 * | 초기화   | —                                      | —                 | client                   |
 * | 다운로드 | `GET /api/v1/inventory/statuses/excel` | —                 | PR #2531 (LOGISPRD-9593) |
 *
 * 위 표 밖의 보조 조회 2건은 필터 옵션 채우기용이다(버튼 동작 아님):
 * - 상품코드 서치헬퍼 `GET /api/v1/master/products/goods-codes` — LOGISPRD-9955 (main 머지 완료)
 * - 센터명 콤보 `GET /api/v1/combos?comboCodes=WH_NM` — 2.0 (LOGISPRD-14161, 1.0 `/api/common/combo` 대체)
 */
export const INVENTORY_STATUSES_URL = '/api/v1/inventory/statuses'
export const INVENTORY_STATUSES_EXCEL_URL = `${INVENTORY_STATUSES_URL}/excel`
export const GOODS_CODE_OPTIONS_URL = '/api/v1/master/products/goods-codes'

/** 조회 요청 URL. */
export const buildInventoryStatusesUrl = (params: GetInventoryStatusesReq) => `${INVENTORY_STATUSES_URL}?${toRepeatQuery(params)}`

/** 엑셀 다운로드 URL. `useExcelDownload` 가 blob 으로 받아 저장한다. */
export const buildInventoryStatusesExcelUrl = (params: DownloadInventoryStatusesReq) => `${INVENTORY_STATUSES_EXCEL_URL}?${toRepeatQuery(params)}`

/** 상품코드 서치헬퍼 URL. */
export const buildGoodsCodeOptionsUrl = (params: GetGoodsCodeOptionsReq) => `${GOODS_CODE_OPTIONS_URL}?${toRepeatQuery(params)}`
